<template>
  <div v-bem @touchstart="hand = false">
    <h2 class="title">{{$t('advantages.title')}}</h2>
    <slick :options="options">
      <div v-for="(avantage, index) in avantages" :key="index">
        <div v-bem:icon><img :src="avantage.icon" :alt="$t(`advantages.advantage${index+1}`)"></div>
        <p v-bem:text>{{$t(`advantages.advantage${index+1}`)}}</p>
      </div>
    </slick>
    <div class="hand" v-if="hand"><img src="@/assets/img/icons/hand.svg" alt=""></div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'Avantages',
  components: {
    Slick
  },
  data() {
    return {
      avantages: [
        {
          icon: require('@/assets/img/icons/discount.svg')
        },
        {
          icon: require('@/assets/img/icons/glob.svg')
        },
        {
          icon: require('@/assets/img/icons/call.svg')
        },
        {
          icon: require('@/assets/img/icons/key.svg')
        }
      ],
      options: {
        arrows    : true,
        dots      : true,
        infinite  : true,
        prevArrow : '<button type="button" class="slick-prev">&#10094;</button>',
        nextArrow : '<button type="button" class="slick-next">&#10095;</button>',
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      hand: true
    }
  }
}
</script>

<style scoped lang="scss">
.avantages {
  position: relative;
  text-align: center;
  margin: rem(100) auto;
  margin: rem(60) auto;
  &__icon {
    position: relative;
    display: inline-block;
    background-color: rgba(var(--primary-color), 1);
    width: rem(120);
    height: rem(120);
    border-radius: 50%;
    margin-bottom: rem(10);
    img {
      height: rem(40);
      @extend %transform-center;
    }
  }
  &__text {
    @include font-size(20);
    max-width: rem(150);
    margin: 0 auto;
  }
  .hand {
    @extend %transform-center;
    top: 60%;
    z-index: 2;
    width: rem(80);
    height: rem(80);
    background: rgba($main-color, 0.3);
    border-radius: 50%;
    display: none;
    pointer-events: none;
    img {
      @extend %transform-center;
      top: 55%;
      left: 65%;
      max-width: rem(50);
      animation: swipe ease-in-out 3s;
			animation-iteration-count: infinite;
    }
    @include breakpoint('charmander') {
      display: block;
    }
  }
  @keyframes swipe {
    0% {
      left: 65%;
    }
    10% {
      left: 65%;
    }
    50% {
      left: 25%;
    }
    70% {
      left: 25%;
    }
    100% {
      left: 65%;
    }
  }
}
</style>